export class JobProgressStepScanningBucketDataTierByClassInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageClass",
            "baseName": "storageClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectCount",
            "baseName": "objectCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bytes",
            "baseName": "bytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepScanningBucketDataTierByClassInner.attributeTypeMap;
    }
    constructor() {
    }
}
